/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Multiple autocomplete, based off of demo
// http://jqueryui.com/demos/autocomplete/#multiple-remote
namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  // Supported options:
  //   resultCount: Limit results to this many
  //   resizeMenu: Callback for autocomplete's _resizeMenu
  //   onSelect: Callback when an option is selected
  return exports.MultiTagAutocomplete = function(el, url, options) {
    if (options == null) { options = {}; }
    options = $.extend({
      resultCount: 5
    }, options);

    //# HELPER FUNCTIONS ##

    // Splits a string on commas, unless the comma is in double quotes
    const splitTagList = function(str) {
      let in_quote = false;
      let term_start = 0;
      const terms = [];

      for (let i = 0, end = str.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
        if (str[i] === '"') { // If it's a double quote
          in_quote = !in_quote;

        } else if (!in_quote && (str[i] === ',')) {
          terms.push(str.substr(term_start, i - term_start).trim());
          term_start = i + 1;
        }
      }

      if (term_start <= str.length) {
        terms.push(str.substr(term_start).trim());
      }

      return terms;
    };

    const extractLast = term => splitTagList(term).pop();

    // Filter +suggestions+ to those that match +term+
    //
    // Don't return any results unless term is at least two characters
    //
    // Limits results to +limit+ count if greater than zero
    const filterSuggestions = function(term, suggestions, limit) {
      if (limit == null) { limit = 0; }
      if (term.length >= 2) {
        const term_re = new RegExp(Slzr.Autocomplete.escapeRegexp(term), 'i');

        let results = _.filter(suggestions, item => term_re.test(item.label));
        if (limit > 0) { results = results.slice(0, limit); }
        return results;
      } 
        return [];
      
    };

    // Per instance cache
    const cache = {};

    // Default options for the input

    $(el)
      .on('keydown', function(event) {
        if ((event.keyCode === $.ui.keyCode.TAB) && $(this).data('ui-autocomplete').menu.active) {
          event.preventDefault();
        }

        if (event.keyCode === $.ui.keyCode.COMMA) {
          if ($(this).data('ui-autocomplete').menu.active) {
            $(this).data('ui-autocomplete').menu.select(event);
            return event.preventDefault();
          } 
            return $(this).data('ui-autocomplete').close();
          
        }
      })
      .autocomplete({
        delay: 100,

        position: {my: 'left top', at: 'left bottom-2', of: options.attachTo || el},

        source(request, response) {
          let term = extractLast(request.term);
          term = term.replace(/^\"|\"$/, ''); // Remove leading/trailing quotes
          term = term.trim();
          const prefix = term.toLowerCase()[0];

          if (!prefix || (prefix === '') || (prefix === ' ') || (prefix === ',')) {
            return response([]);
          } else if (cache[prefix]) {
            return response(filterSuggestions(term, cache[prefix], options.resultCount));
          } 
            // Preload all results starting with the first character, for better responsiveness
            return $.getJSON(url, {term: prefix}, function(data) {
              cache[prefix] = data;
              return response(filterSuggestions(term, cache[prefix], options.resultCount));
            });
          
        },

        focus() {
          // Prevent value from being inserted on focus
          return false;
        },

        // Force it to always search, regardless of input
        search() { return true; },

        select(event, ui) {
          if (options.onSelect != null) {
            if (options.onSelect(ui.item.value)) {
              this.value = '';
            }

            return false;
          } 
            const terms = splitTagList(this.value);
            // Remove current value
            terms.pop();
            // Add selected item, in quotes if it contains a comma
            let new_item = ui.item.value;
            if (new_item.match(/,/)) { new_item = `"${  new_item  }"`; }
            terms.push(new_item);
            // Add placeholder to get comma space at end
            terms.push('');

            // Comma separate it
            this.value = terms.join(', ');
            return false;
          
        }
    });

    const autocomplete = $(el).data('ui-autocomplete');

    // Provide hook for _resizeMenu
    const _superResizeMenu = autocomplete._resizeMenu;
    autocomplete._resizeMenu = function() {
      if (options.resizeMenu != null) {
        return options.resizeMenu(this.menu.element);
      } 
        return _superResizeMenu();
      
    };

    // Override render item with a custom formatter
    autocomplete._renderItem = function(ul, item) {
      let count_div;
      const escaped_entry = Slzr.Autocomplete.escapeRegexp(this.term);
      const replacement = new RegExp(`(${escaped_entry})`, "ig");
      const highlighted_label = item.label.replace(replacement, '<strong class="highlight">$1</strong>');

      const label_div = $('<a>').html(highlighted_label);

      if ((item.count != null) && (item.list_url != null)) {
        const count_label = `${item.count} event${item.count !== 1 ? 's' : ''}`;
        count_div = $('<a>').attr({
          href:   item.list_url,
          target: '_blank',
          class:  'autocomplete-link'}).html(count_label).click(event => // Not preventing default action, but stop other handlers, as we still want the link to open,
        // but not add to list
        event.stopPropagation());
      } else {
        count_div = null;
      }

      return $('<li></li>')
        .data('ui-autocomplete-item', item)
        .append([label_div, count_div])
        .appendTo(ul);
    };

    return autocomplete;
  };
});